import { action } from "@ember/object";
import { service } from "@ember/service";
import CreateInvite from "discourse/components/modal/create-invite";
import GroupIndexRoute from "discourse/routes/group/index";
import { i18n } from "discourse-i18n";
import CircleAddMembersModal from "discourse/plugins/discourse-circles/discourse/components/modal/add-members";

export default class CircleMembersRoute extends GroupIndexRoute {
  @service modal;

  titleToken() {
    return i18n("discourse_circles.circle.members.title_token", {
      circle_name: this.modelFor("circle").name,
    });
  }

  model(params) {
    this._params = params; // from GroupIndexRoute#model

    return this.group;
  }

  get mode() {
    return "members";
  }

  get circle() {
    return this.modelFor("circle");
  }

  get group() {
    return this.circle?.member_group;
  }

  @action
  showAddMembersModal() {
    this.modal.show(CircleAddMembersModal, {
      model: {
        circle: this.circle,
        group: this.group,
        mode: this.mode,
        reloadMembers: () => {
          this.controller.reloadMembers(true);
        },
      },
    });
  }

  @action
  showInviteModal() {
    this.modal.show(CreateInvite, { modal: { groupIds: [this.group.id] } });
  }
}
